<template>
  <div class="searchExams__not-found">
    <div class="searchExams__not-found--icon">
      <BeakerSvg />
    </div>
    <p class="searchExams__not-found--title">É isso mesmo?</p>
    <p class="searchExams__not-found--subtitle">
      Não encontrei o serviço que procurou.<br />Confira se o nome está correto.
    </p>
  </div>
</template>

<script>
export default {
  name: 'NotFoundExamsPartial',
};
</script>

<style lang="scss">
.searchExams {
  &__not-found {
    padding-top: 40px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;

    &--icon {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 72px;
      height: 72px;
      border-radius: 50%;
      background-color: #e6ebff;
    }

    &--title {
      font-weight: 700;
      font-size: 16px;
      line-height: 120%;
      color: #292929;
      padding-top: 24px;
    }

    &--subtitle {
      font-size:14px;
      line-height: 150%;
      color: #363636;
    }
  }
}
</style>
